import { useRef, useEffect } from 'react';
import Valor from './Valor';
import Volanta from '@/components/Volanta';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin';
import BigGreenPointer from '@/components/Home/Elegirnos/Svgs/biggreenpointer';
import OrangeBigDrop from '@/components/Empresas/Hero/Svgs/OrangeBigDrop';
import ElegirnosAnimacion from '@/components/Home/Elegirnos/Animacion';
import cn from 'classnames';
import styles from 'styles/pages/index.module.scss';
import { gsap } from 'gsap';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

const Valores = ({ choose_reasons, values }) => {
  const section = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      '.value-line-js',
      {
        drawSVG: '0% 0%'
      },
      {
        scrollTrigger: {
          trigger: section.current,
          start: 'top center',
          end: '+=60%',
          scrub: true
          // markers: true
        },
        drawSVG: '0% 100%'
      }
    );
  }, []);

  return (
    <section
      ref={section}
      className="w-full relative site-max bg-cyan-light pt-60 pb-140 rounded-[3rem] sm:rounded-[6.4rem] overflow-hidden"
    >
      <div
        className={cn(
          'hidden sm:block absolute z-1 top-320 sm:top-[55rem] -right-50 sm:-right-110',
          styles.elegirnosBigGreenPointer
        )}
      >
        <BigGreenPointer />
      </div>
      <div
        className={cn(
          'hidden sm:block absolute z-1 top-320 sm:top-[105rem] -left-50 sm:-left-110',
          styles.elegirnosBigGreyPointer
        )}
      >
        <div className="-rotate-90">
          <OrangeBigDrop />
        </div>
      </div>

      <div className="site-grid">
        <div className="col-span-4 lg:col-start-2 lg:col-span-11">
          <div className="relative mb-90 opacity-90">
            <Volanta label="NUESTROS VALORES" />
          </div>
        </div>
        <div className="relative col-span-4 md:col-start-2 lg:col-start-3 md:col-span-8 sm:pl-45">
          <div className="absolute top-[4%] left-[5.5%] lg:left-[7.2%]">
            <svg
              className="w-8 h-auto"
              viewBox="0 0 8 455"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_3605_11770)">
                <path
                  d="M4.00003 2.82178L4 450.082"
                  stroke="#1D1D1B"
                  strokeOpacity="0.12"
                  strokeWidth="7"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  className="value-line-js"
                  d="M4.00003 2.82178L4 450.092"
                  stroke="url(#paint0_linear_3605_11770)"
                  strokeWidth="7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_3605_11770"
                  x1="5.12372"
                  y1="477.066"
                  x2="-165.399"
                  y2="405.332"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#EE4424" />
                  <stop offset="0.571417" stopColor="#FD813E" />
                  <stop offset="1" stopColor="#22CDC6" />
                </linearGradient>
                <clipPath id="clip0_3605_11770">
                  <rect width="8" height="455" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="mb-75 sm:mb-150">
            <Valor
              bgColor="bg-cyan"
              number="1"
              title={values[0].title}
              text={values[0].description}
            />
          </div>
          <div className="mb-75 sm:mb-150">
            <Valor
              bgColor="bg-cyan"
              number="2"
              title={values[1].title}
              text={values[1].description}
            />
          </div>
          <div className="mb-60 sm:mb-180">
            <Valor
              bgColor="bg-cyan"
              number="3"
              title={values[2].title}
              text={values[2].description}
            />
          </div>
        </div>
      </div>
      <ElegirnosAnimacion choose_reasons={choose_reasons} />
    </section>
  );
};
export default Valores;
